import React from "react";
import "../../General/Appearance.css";
import "./BlockUser.css";
import Button from "@material-ui/core/Button";
import TextTheme from "../../General/Text/TextTheme";
import * as CONSTANT from "constants/text";
//import { BLOCK_WARNING } from "constants/text";
import CustomDecisionPopup from "components/General/Form/Popup/CustomDecisionPopup";
/*Friend Request methods*/
import * as FriendRequest from "components/Tribe/Friends/FriendRequestMethods";
import { Fragment } from "react";

class BlockUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username_to_block: props.username_to_block,
      displayWarning: false,
    };
    /*function binding*/
    this.onBlockClicked = this.onBlockClicked.bind(this);
    this.onBlockDecline = this.onBlockDecline.bind(this);
  }

  onBlockClicked() {
    this.setState({ displayWarning: true });
  }

  onBlockDecline() {
    this.setState({ displayWarning: false });
  }

  render() {
    return (
      <Fragment>
        {this.props.showAsText ? (
          <div className="block_text text_bold" onClick={this.onBlockClicked}>
            {CONSTANT.BLOCK_USER + this.state.username_to_block}
          </div>
        ) : (
          <div className="block_text">
            <Button
              size="small"
              variant="outlined"
              component="span"
              style={{
                textTransform: "None",
                margin: "0px",
                border: "0px solid",
                float: "left",
                width: "",
                padding:"0px",
                background:"none"
              }}
              onClick={this.onBlockClicked}
            >
              <TextTheme
                message={CONSTANT.BLOCK_USER + this.state.username_to_block}
                className={"text_xsmall text_semi_bold upload-photo"}
              />
            </Button>
          </div>
        )}

        {this.state.displayWarning ? (
          <CustomDecisionPopup
            isOpen={true}
            popupTitle={CONSTANT.BLOCK + this.state.username_to_block + "?"}
            popupDescription={
              CONSTANT.BLOCK_WARNING1 +
              this.state.username_to_block +
              "? " +
              CONSTANT.BLOCK_WARNING2
            }
            popupDescription2={CONSTANT.BLOCK_WARNING}
            acceptButtonText={CONSTANT.ACCEPT_BLOCK}
            declineButtonText={CONSTANT.DECLINE_BLOCK}
            acceptButtonClick={() =>
              FriendRequest.block(
                this.state.username_to_block,
                this.props.blockType
              )
            }
            declineButtonClick={this.onBlockDecline}
          />
        ) : null}
      </Fragment>
    );
  }
}

export default BlockUser;
